import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';

export interface ImageDialogData {
  imagePath: string;
  titleTranslationKey: string;
  imageAltTranslationKey?: string;
  imageMissingTranslationKey?: string;
}

@Component({
  selector: 'app-image-dialog',
  template: `
    <h2 mat-dialog-title>{{ data.titleTranslationKey | translate }}</h2>
    <mat-dialog-content>
      @if (!imageLoadFailed()) {
        <img
          [src]="data.imagePath"
          [alt]="(data.imageAltTranslationKey ?? data.titleTranslationKey) | translate"
          class="image"
          (error)="onImageLoadError()"
        />
      } @else {
        <p>{{ data.imageMissingTranslationKey ?? 'downyMildew.observation.exampleImageMissing' | translate }}</p>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>{{ 'close' | translate }}</button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .image {
        max-width: 100%;
        max-height: 60vh;
        display: block;
        margin: 0 auto;
      }
    `,
  ],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, AgrI18nSharedModule],
})
export class ImageDialogComponent {
  readonly data = inject<ImageDialogData>(MAT_DIALOG_DATA);
  protected readonly imageLoadFailed = signal(false);

  protected onImageLoadError(): void {
    this.imageLoadFailed.set(true);
  }
}
